import { Icon, IconButton } from "@mui/material";
import React from "react";
import { theme } from "../../../config/theme";

export default function CustomPagination(props) {
  console.log("props", props);
  const { page, count, rowsPerPage } = props;

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-evenly",
        alignItems: "center",
      }}
    >
      <p style={{ marginTop: 0, marginBottom: 0 }}>Page</p>
      <IconButton
        onClick={(e) => {
          props.onPageChange(e, page > 0 ? page - 1 : 0);
        }}
      >
        <Icon>chevron_left</Icon>
      </IconButton>
      <p
        style={{
          paddingTop: 2,
          marginTop: 0,
          marginBottom: 0,
          height: 32,
          width: 32,
          backgroundColor: theme.palette.primary.main,
          borderRadius: 50,
          textAlign: "center",
          color: theme.palette.primary.contrastText,
        }}
      >
        {props.page + 1}
      </p>
      <IconButton
        onClick={(e) => {
          props.onPageChange(
            e,
            page < Math.ceil(count / rowsPerPage) - 1 ? page + 1 : page,
          );
        }}
      >
        <Icon>chevron_right</Icon>
      </IconButton>
    </div>
  );
}
